import type { GetHashtags200DataItem } from './getHashtags200DataItem';

export type GetHashtags200 = {
  data?: GetHashtags200DataItem[];
};
